import FormValidators from '@/components/FormValidators';

export default class AnketaForm extends FormValidators {
   formOptions: any = {
      validateAfterLoad: false,
      validateAfterChanged: true,
      validateAsync: true,
   };

   mounted(): void {}
}
